import React, { useContext, useState } from 'react';

import { Box, FormHelperText, FormLabel, Grid, Stack, styled } from '@mui/material';

import { object, ref, string } from 'yup';

import ToastContext from '../../Context/ToastContext';

import Layout from './Components/Layout';
import PasswordField from '../../Components/PasswordField';

import FireBase from '../../lib/fireBaseProfessional';

const RegisterProfessional3 = () => {
  const { showToastMessage } = useContext(ToastContext);

  const [isSaveDisabled, setIsSaveDisabled] = useState(false);
  const [inputs, setInputs] = useState({
    oldPassword: '',
    newPassword: '',
    confirmPassword: '',
  });
  const [errors, setErrors] = useState({
    oldPassword: null,
    newPassword: null,
    confirmPassword: null,
  });

  const handleChange = ({ target: { name, value } }) =>
    setInputs(prevStates => ({ ...prevStates, [name]: value }));

  const handleClickSave = async () => {
    clearErrors();
    setIsSaveDisabled(true);
    try {
      const { oldPassword, newPassword } = await schema.validate(inputs, {
        abortEarly: false,
      });

      await FireBase.updatePassword(oldPassword, newPassword);
      showToastMessage('Password updated successfully', 'success');
    } catch (error) {
      switch (error.name) {
        case 'ValidationError': {
          const [validationError] = error.inner;
          setErrors(currentErrors => ({
            ...currentErrors,
            [validationError.path]: validationError.message,
          }));
          break;
        }
        case 'FirebaseError':
          if (error.code === 'auth/wrong-password') {
            showToastMessage('Current password is incorrect', 'error');
            break;
          } //fall through to other firebase errors
        default:
          showToastMessage('Oops! Something went wrong!', 'error');
      }
    } finally {
      setIsSaveDisabled(false);
    }
  };

  const clearErrors = () =>
    setErrors(currentErrors =>
      Object.fromEntries(Object.keys(currentErrors).map(key => [key, null]))
    );

  const handleClickCancel = () => {
    clearErrors();
    setInputs(prevInputs => Object.fromEntries(Object.keys(prevInputs).map(key => [key, ''])));
  };

  return (
    <Layout
      message='Update your Password'
      handleClickSave={handleClickSave}
      handleClickCancel={handleClickCancel}
      isSaveDisabled={isSaveDisabled}
    >
      <Stack gap={3} maxWidth={{ xs: '300px', md: '70%' }} mx={{ xs: 'auto', md: 'unset' }}>
        <Box
          display='grid'
          gap={0.5}
          gridTemplateColumns={{ md: '150px 1fr' }}
          alignItems={{ md: 'center' }}
        >
          <FormLabel>Current Password*</FormLabel>
          <PasswordField
            name='oldPassword'
            value={inputs.oldPassword}
            onChange={handleChange}
            error={errors.oldPassword}
          />
          <FormHelperText sx={{ gridColumnStart: { md: '2' } }} error={errors.oldPassword}>
            {errors.oldPassword}
          </FormHelperText>
        </Box>
        <Box
          display='grid'
          gap={0.5}
          gridTemplateColumns={{ md: '150px 1fr' }}
          alignItems={{ md: 'center' }}
        >
          <FormLabel>New Password*</FormLabel>
          <PasswordField
            name='newPassword'
            value={inputs.newPassword}
            onChange={handleChange}
            error={errors.newPassword}
          />
          <FormHelperText sx={{ gridColumnStart: { md: '2' } }} error={errors.newPassword}>
            {errors.newPassword}
          </FormHelperText>
        </Box>
        <Box
          display='grid'
          gap={0.5}
          gridTemplateColumns={{ md: '150px 1fr' }}
          alignItems={{ md: 'center' }}
        >
          <FormLabel>Confirm Password*</FormLabel>
          <PasswordField
            name='confirmPassword'
            value={inputs.confirmPassword}
            onChange={handleChange}
            error={errors.confirmPassword}
          />
          <FormHelperText sx={{ gridColumnStart: { md: '2' } }} error={errors.confirmPassword}>
            {errors.confirmPassword}
          </FormHelperText>
        </Box>
      </Stack>
    </Layout>
  );
};

const schema = object({
  oldPassword: string().label('Current password').required(),
  newPassword: string().label('New password').required().min(6).max(12),
  confirmPassword: string()
    .label('Confirm password')
    .required()
    .oneOf([ref('newPassword')], 'Password do not match'),
});

export default RegisterProfessional3;
